import Swiper from 'swiper';
import {
    Keyboard, Pagination, Virtual, Manipulation, A11y, Mousewheel, Autoplay, Navigation
} from 'swiper/modules';

export class Slider {
    constructor(props) {
        document.querySelectorAll('.has-swiper .swiper').forEach(swiper => {
            new Swiper(swiper, {
                modules: [Pagination, Keyboard, Virtual, Autoplay, Manipulation, A11y, Mousewheel, Navigation],
                speed: 1000,
                autoplay: {
                    delay: 6000
                },
                spaceBetween: 30,
                loop: true,
                keyboard: {
                    enabled: true,
                },
                navigation: {
                    nextEl: swiper.closest('.has-swiper').querySelector('.swiper-button-next'),
                    prevEl: swiper.closest('.has-swiper').querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: swiper.closest('.has-swiper').querySelector('.swiper-pagination'),
                    clickable: true,
                    type: 'bullets',
                },
            });
        })
    }


}
